import Vue from "vue";
import Component from "vue-class-component";
import { IPaymentArticles } from "@/entity/finance/payment_articles/paymentArticles.types";
import { PaymentArticlesStore } from "@/store/modules/PaymentArticles";

@Component
export class PaymentArticlesMix extends Vue {
    get paymentArticles(): IPaymentArticles | null {
        return PaymentArticlesStore.paymentArticles;
    }
}
